<template>
  <div class="villa-form-container">
    <div class="card-header">
      <span>{{ isEditMode ? '编辑别墅' : '添加别墅' }}</span>
    </div>
    <el-form :model="villaForm" :rules="rules" ref="villaFormRef" label-width="180px" label-position="left">
      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item label="别墅名称:" prop="houseName" class="form-item-input">
            <el-input v-model="villaForm.houseName" placeholder="请输入别墅名称" clearable />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="别墅类型:" prop="houseType" class="form-item-input">
            <el-select v-model="villaForm.houseType" placeholder="请选择别墅类型" style="width: 100%">
              <el-option v-for="item in villaTypes" :key="item.value" :label="item.label" :value="item.value" />
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item label="是否火爆:" prop="isHot" class="form-item-input">
            <el-select v-model="villaForm.isHot" placeholder="请选择" style="width: 100%">
              <el-option label="是" :value="1" />
              <el-option label="否" :value="0" />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="是否展示在首页轮播:" prop="isShowBanner" class="form-item-input">
            <el-select v-model="villaForm.isShowBanner" placeholder="请选择" style="width: 100%">
              <el-option label="是" :value="1" />
              <el-option label="否" :value="0" />
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item label="是否本月新增:" prop="isNew" class="form-item-input">
            <el-select v-model="villaForm.isNew" placeholder="请选择" style="width: 100%">
              <el-option label="是" :value="1" />
              <el-option label="否" :value="0" />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="Banner跳转路径:" prop="bannerLink" class="form-item-input">
            <el-input v-model="villaForm.bannerLink" placeholder="请输入Banner跳转路径" clearable />
          </el-form-item>
        </el-col>
      </el-row>

      <el-form-item label="别墅风格:" prop="styleTypes">
        <el-checkbox-group v-model="villaForm.styleTypes">
          <el-checkbox v-for="style in villaStyles" :key="style.value" :value="style.value">
            {{ style.label }}
          </el-checkbox>
        </el-checkbox-group>
      </el-form-item>

      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item label="商品图片:" prop="productImage">
            <el-upload class="product-uploader" action="#" :auto-upload="false" :show-file-list="false"
              :on-change="handleProductImageChange" :disabled="productIsUploading">
              <img v-if="villaForm.imagePreview" :src="villaForm.imagePreview" class="product-image" />
              <el-icon v-else class="product-uploader-icon">
                <Plus />
                <div class="upload-text">请选择别墅图片上传</div>
              </el-icon>
            </el-upload>

            <div v-show="productIsUploading || productProgress > 0" class="progress-wrap">
              <div class="progress-tip">
                {{ productProgressTip }}
              </div>
              <el-progress
                :percentage="productProgress"
                :stroke-width="6"
                :status="productProgress >= 100 ? 'success' : ''" />
            </div>

            <div v-if="villaForm.imagePreview && !productIsUploading" class="image-actions">
              <el-button type="danger" size="small" @click="removeProductImage">删除</el-button>
            </div>
          </el-form-item>
        </el-col>

        <el-col :span="12">
          <el-form-item label="施工图PDF:" prop="pdfUrl">
            <el-upload class="product-uploader" action="#" :auto-upload="false" :show-file-list="false" accept=".pdf"
              :on-change="handlePdfChange" :disabled="pdfIsUploading">
              <el-icon v-if="!villaForm.pdfUrl" class="product-uploader-icon">
                <Upload />
                <div class="upload-text">请选择施工图上传</div>
              </el-icon>
              <div v-else class="pdf-info">
                <el-icon class="pdf-icon"><Document /></el-icon>
                <span>{{ villaForm.constructionPdfName }}</span>
              </div>
            </el-upload>

            <div v-show="pdfIsUploading || pdfProgress > 0" class="progress-wrap">
              <div class="progress-tip">{{ pdfProgressTip }}</div>
              <el-progress
                :percentage="pdfProgress"
                :stroke-width="6"
                :status="pdfProgress >= 100 ? 'success' : ''" />
            </div>

            <div v-if="villaForm.pdfUrl && !pdfIsUploading" class="image-actions">
              <el-button type="danger" size="small" @click="removePdf">删除</el-button>
            </div>
          </el-form-item>
        </el-col>
      </el-row>

      <el-form-item v-if="!isEditMode" label="详情图:" prop="detailImages">
        <el-upload
          class="detail-uploader"
          action="#"
          :auto-upload="false"
          :show-file-list="false"
          multiple
          :on-change="handleDetailImageChange"
          :disabled="detailIsUploading"
        >
          <el-button>
            <el-icon><Upload /></el-icon>
            批量选择详情图
          </el-button>
        </el-upload>

        <div v-show="detailIsUploading || detailProgress > 0" class="progress-wrap">
          <div class="progress-tip">{{ detailProgressTip }}</div>
          <el-progress
            :percentage="detailProgress"
            :stroke-width="6"
            :status="detailProgress >= 100 ? 'success' : ''" />
        </div>

        <div class="detail-images-list">
          <div v-for="(item, index) in villaForm.detailImages" :key="item.id" class="detail-image-item">
            <img :src="item.url" class="detail-image" />
            <div class="detail-image-actions">
              <el-input v-model.number="item.order" size="small" class="order-input" placeholder="顺序" />
              <el-button type="danger" size="small" @click="removeDetailImage(index)">删除</el-button>
            </div>
          </div>
        </div>
      </el-form-item>

      <el-form-item class="button-group">
        <el-button type="primary" @click="submitForm" class="submit-button">
          {{ isEditMode ? '保存修改' : '提交' }}
        </el-button>
        <el-button v-if="!isEditMode" @click="resetForm" class="submit-button">重置</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script setup>
import { ref, reactive, computed, getCurrentInstance, onMounted } from 'vue'
import { ElMessage } from 'element-plus'
import { Plus, Upload, Document } from '@element-plus/icons-vue'
import { useRoute, useRouter } from 'vue-router'
import OSS from 'ali-oss'

const route = useRoute()
const router = useRouter()
const isEditMode = ref(false)
const villaFormRef = ref()
const { proxy } = getCurrentInstance()

const villaTypes = [
  { label: '一层别墅', value: '1' },
  { label: '二层别墅', value: '2' },
  { label: '三层别墅', value: '3' },
  { label: '双拼别墅', value: '4' },
  { label: '火爆户型', value: '5' },
  { label: '本月新增', value: '6' }
]
const villaStyles = [
  { label: '中式', value: '1' },
  { label: '新中式', value: '2' },
  { label: '合院', value: '3' },
  { label: '简欧风', value: '4' },
  { label: '现代风', value: '5' }
]

// ========== 进度 + 上传锁 ==========
const productProgress = ref(0)
const pdfProgress = ref(0)
const detailProgress = ref(0)

const productIsUploading = ref(false)
const pdfIsUploading = ref(false)
const detailIsUploading = ref(false)

// 虚拟动画定时器保存
let productFakeTimer = null
let pdfFakeTimer = null
let detailFakeTimer = null
let detailDebounceTimer = null
let pendingDetailFiles = []

// 进度文案
const productProgressTip = computed(() => {
  if (productProgress.value >= 100) return '上传成功'
  if (productIsUploading.value && productProgress.value < 5) return '正在获取上传凭证...'
  if (productIsUploading.value && productProgress.value < 30) return '正在初始化上传...'
  return '正在上传...'
})
const pdfProgressTip = computed(() => {
  if (pdfProgress.value >= 100) return '上传成功'
  if (pdfIsUploading.value && pdfProgress.value < 5) return '正在获取上传凭证...'
  if (pdfIsUploading.value && pdfProgress.value < 30) return '正在初始化上传...'
  return '正在上传...'
})
const detailProgressTip = computed(() => {
  if (detailProgress.value >= 100) return '全部上传成功'
  if (detailIsUploading.value && detailProgress.value < 5) return '正在获取上传凭证...'
  if (detailIsUploading.value && detailProgress.value < 30) return '正在初始化上传...'
  return `正在上传 ${uploadingDetailIndex.value+1}/${uploadingDetailTotal.value} ...`
})

const villaForm = reactive({
  houseId: '',
  houseName: '',
  houseType: '',
  styleTypes: [],
  bannerLink: '',
  isHot: 0,
  isShowBanner: 0,
  isNew: 0,
  imageUrl: '',
  imagePreview: '',
  pdfUrl: '',
  constructionPdfName: '',
  detailImages: []
})

const rules = {
  houseName: [{ required: true, message: '请输入别墅名称', trigger: 'blur' }],
  houseType: [{ required: true, message: '请选择别墅类型', trigger: 'change' }]
}

let uploadingDetailIndex = ref(0)
let uploadingDetailTotal = ref(0)

// 启动虚拟进度：缓慢爬到30，拿到真实进度后外部手动clear
function startFakeProgress(progressRef) {
  progressRef.value = 2
  const timer = setInterval(() => {
    if (progressRef.value >= 30) return
    const step = 0.4
    progressRef.value = Math.min(30, progressRef.value + step)
  }, 120)
  return timer
}

// 秒传补动画：平滑走到100
function animateToFull(progressRef, duration = 700) {
  const startVal = progressRef.value
  if (startVal >= 100) return Promise.resolve()
  const start = performance.now()
  return new Promise(resolve => {
    function tick(now) {
      const ratio = Math.min(1, (now - start) / duration)
      progressRef.value = Math.floor(startVal + (100 - startVal) * ratio)
      if (ratio < 1) {
        requestAnimationFrame(tick)
      } else {
        progressRef.value = 100
        resolve()
      }
    }
    requestAnimationFrame(tick)
  })
}

async function getStsInfo() {
  const res = await fetch(process.env.VUE_APP_BASE_URL + '/upload/sts')
  return await res.json()
}

// 单文件上传（复用）
async function uploadSingleFile(file, fakeTimerRef) {
  const sts = await getStsInfo()
  const client = new OSS({
    region: 'cn-shanghai',
    endpoint: 'oss-cn-shanghai.aliyuncs.com',
    accessKeyId: sts.accessKeyId,
    accessKeySecret: sts.accessKeySecret,
    stsToken: sts.securityToken,
    bucket: sts.bucket,
    partSize: 1024 * 1024
  })
  const uuid = crypto.randomUUID()
  const fileName = uuid + '_' + file.name

  await client.multipartUpload(fileName, file, {
    progress: (p) => {
      if (fakeTimerRef) {
        clearInterval(fakeTimerRef)
        console.log('进度：', p )
        fakeTimerRef = null
      }
    }
  })
  return `${sts.cdnDomain}/${fileName}`
}

// 通用上传逻辑（单文件：主图、PDF）
async function runUpload(file, progressRef, uploadingRef, fakeTimerRef) {
  uploadingRef.value = true
  progressRef.value = 2
  fakeTimerRef = startFakeProgress(progressRef)

  try {
    const url = await uploadSingleFile(file, fakeTimerRef)
    return url
  } catch (err) {
    if (fakeTimerRef) {
      clearInterval(fakeTimerRef)
      fakeTimerRef = null
    }
    console.error('上传异常', err)
    ElMessage.error('上传失败：' + err.message)
    return null
  } finally {
    uploadingRef.value = false
  }
}

// ========== 主图 ==========
const handleProductImageChange = async (fileObj) => {
  const file = fileObj.raw
  if (!file || productIsUploading.value) return
  villaForm.imagePreview = URL.createObjectURL(file)

  const url = await runUpload(file, productProgress, productIsUploading, productFakeTimer)
  if (url) {
    villaForm.imageUrl = url
    await animateToFull(productProgress)
    ElMessage.success('图片上传成功')
  }
  setTimeout(() => {
    productProgress.value = 0
  }, 1600)
}
const removeProductImage = () => {
  villaForm.imageUrl = ''
  villaForm.imagePreview = ''
  productProgress.value = 0
}

// ========== PDF ==========
const handlePdfChange = async (file) => {
  const raw = file.raw
  if (!raw || pdfIsUploading.value) return
  villaForm.constructionPdfName = file.name

  const url = await runUpload(raw, pdfProgress, pdfIsUploading, pdfFakeTimer)
  if (url) {
    villaForm.pdfUrl = url
    await animateToFull(pdfProgress)
    ElMessage.success('PDF上传成功')
  }
  setTimeout(() => {
    pdfProgress.value = 0
  }, 1600)
}
const removePdf = () => {
  villaForm.pdfUrl = ''
  villaForm.constructionPdfName = ''
  pdfProgress.value = 0
}

// ========== 详情图【批量修复】 ==========
let detailImageId = 0
const handleDetailImageChange = (file, fileList) => {
  if (detailIsUploading.value) return
  // 收集raw文件
  pendingDetailFiles = fileList.map(f => f.raw)
  // 防抖：多选时等选择完毕再开始上传
  clearTimeout(detailDebounceTimer)
  detailDebounceTimer = setTimeout(startBatchUploadDetail, 150)
}

async function startBatchUploadDetail() {
  if (!pendingDetailFiles.length) return
  detailIsUploading.value = true
  detailProgress.value = 2
  detailFakeTimer = startFakeProgress(detailProgress)

  const files = [...pendingDetailFiles]
  pendingDetailFiles = []
  uploadingDetailTotal.value = files.length
  uploadingDetailIndex.value = 0

  try {
    for (let i = 0; i < files.length; i++) {
      uploadingDetailIndex.value = i
      const url = await uploadSingleFile(files[i], detailFakeTimer)
      if (url) {
        villaForm.detailImages.push({
          id: detailImageId++,
          url: url,
          order: villaForm.detailImages.length + 1
        })
      }
      // 每传完一张更新总进度
      detailProgress.value = Math.floor(((i + 1) / files.length) * 100)
    }
    await animateToFull(detailProgress, 400)
    ElMessage.success(`共 ${files.length} 张详情图上传完成`)
  } catch (err) {
    console.error('批量详情图上传失败', err)
    ElMessage.error('详情图上传出错')
  } finally {
    detailIsUploading.value = false
    clearInterval(detailFakeTimer)
    detailFakeTimer = null
    setTimeout(() => {
      detailProgress.value = 0
    }, 1600)
  }
}

const removeDetailImage = (index) => {
  villaForm.detailImages.splice(index, 1)
  villaForm.detailImages.forEach((item, i) => {
    item.order = i + 1
  })
}

// ========== 表单提交 ==========
const submitForm = () => {
  villaFormRef.value.validate((valid) => {
    if (valid) {
      const submitData = {
        ...villaForm,
        style: Array.isArray(villaForm.styleTypes) ? villaForm.styleTypes.join(',') : villaForm.styleTypes,
        isHot: parseInt(villaForm.isHot),
        isShowBanner: parseInt(villaForm.isShowBanner),
        isNew: parseInt(villaForm.isNew)
      }
      if (isEditMode.value) {
        updateProduct(submitData)
      } else {
        addProduct(submitData)
      }
      router.push('/houseCart/houseManage')
    } else {
      ElMessage.error('请完善必填信息')
    }
  })
}

const addProduct = () => {
  const url = '/house/addHouse'
  proxy.$tools.request(url, { reqBody: villaForm }).then(response => {
    const code = response.data.rspHead.returnCode
    if (code === '00000000') {
      ElMessage.success('添加成功')
      window.location.reload()
    } else {
      ElMessage.error('提交商品失败，请重试！')
    }
  }).catch(error => {
    ElMessage.error('提交商品失败，请重试！')
    console.error(error)
  })
}

const updateProduct = (submitData) => {
  const url = '/house/updateHouse'
  proxy.$tools.request(url, { reqBody: submitData }).then(response => {
    const code = response.data.rspHead.returnCode
    if (code === '00000000') {
      ElMessage.success('更新成功')
    } else {
      ElMessage.error('更新别墅失败，请重试！')
    }
  }).catch(error => {
    ElMessage.error('更新别墅失败，请重试！')
    console.error(error)
  })
}

const resetForm = () => {
  villaFormRef.value.resetFields()
  if (isEditMode.value) {
    onMounted()
  } else {
    villaForm.imagePreview = ''
    villaForm.pdfUrl = ''
    villaForm.constructionPdfName = ''
    villaForm.detailImages = []
    productProgress.value = 0
    pdfProgress.value = 0
    detailProgress.value = 0
  }
}

onMounted(() => {
  if (route.query.mode === 'edit' && route.query.data) {
    isEditMode.value = true
    try {
      const houseData = JSON.parse(decodeURIComponent(route.query.data))
      villaForm.houseId = houseData.houseId
      villaForm.houseName = houseData.houseName
      villaForm.houseType = houseData.houseType
      if (houseData.style) {
        if (typeof houseData.style === 'string') {
          villaForm.styleTypes = houseData.style ? houseData.style.split(',') : []
        } else if (Array.isArray(houseData.style)) {
          villaForm.styleTypes = houseData.style
        } else {
          villaForm.styleTypes = []
        }
      } else {
        villaForm.styleTypes = []
      }
      villaForm.bannerLink = houseData.bannerLink
      villaForm.isHot = parseInt(houseData.isHot) || 0
      villaForm.isShowBanner = parseInt(houseData.isShowBanner) || 0
      villaForm.isNew = parseInt(houseData.isNew) || 0
      villaForm.imageUrl = houseData.houseImageUrl
      villaForm.imagePreview = houseData.houseImageUrl
      villaForm.pdfUrl = houseData.workingDrawingPdf
      villaForm.constructionPdfName = houseData.constructionPdfName
    } catch (e) {
      ElMessage.error('数据解析失败')
      console.error(e)
    }
  }
})
</script>

<style scoped>
.villa-form-container {
  padding-left: 60px;
  padding-right: 60px;
  padding-top: 20px;
  max-width: 100%;
  margin: 0 auto;
}
.card-header {
  font-size: 18px;
  font-weight: bold;
  margin-bottom: 40px;
  margin-left: -170px;
}
.form-item-input {
  width: 400px;
  font-size: 14px;
  color: #333;
  font-weight: 400;
  line-height: 40px;
}
.product-uploader .product-image {
  width: 300px;
  height: 300px;
  display: block;
}
.product-uploader .product-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 220px;
  height: 220px;
  text-align: center;
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
.upload-text {
  margin-top: 10px;
  font-size: 12px;
  font-weight: 400;
}
.product-uploader :hover {
  border-color: #409eff;
}
.product-uploader :deep(.el-upload:hover) {
  border-color: #409eff;
}
.image-actions {
  margin-top: 10px;
}
.pdf-info {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 10px;
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  max-width: 300px;
}
.pdf-icon {
  font-size: 24px;
  color: #f56c6c;
}
.progress-wrap {
  width: 300px;
  margin-top: 8px;
}
.progress-tip {
  font-size: 12px;
  color: #909399;
  margin-bottom: 4px;
}
.detail-images-list {
  margin-top: 10px;
}
.detail-image-item {
  display: flex;
  align-items: center;
  margin-bottom: 10px;
  padding: 10px;
  border: 1px solid #ebeef5;
  border-radius: 4px;
}
.detail-image {
  width: 300px;
  height: 300px;
  object-fit: cover;
  margin-right: 15px;
}
.detail-image-actions {
  display: flex;
  align-items: center;
  gap: 10px;
}
.order-input {
  width: 80px;
}
:deep(.el-checkbox-group) {
  display: flex;
  gap: 20px;
}
.button-group {
  margin-top: 40px;
  margin-left: 200px;
}
.submit-button {
  width: 120px;
  height: 35px;
}
</style>
